var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11049",
    d: "M1.411-1.666a4.067 4.067 0 0 0 0-5.745 4.037 4.037 0 0 0-1.295-.871.372.372 0 0 0-.5.227 2.337 2.337 0 0 0-.088.477.377.377 0 0 0 .223.365 2.918 2.918 0 0 1 .862.6 2.941 2.941 0 0 1 .014 4.141l-.011.011L-1.859.014a2.936 2.936 0 0 1-4.154 0 2.936 2.936 0 0 1 0-4.154l2.353-2.353a.377.377 0 0 0 .106-.315q-.029-.224-.038-.449a.375.375 0 0 0-.631-.259l-.11.106-2.476 2.474a4.06 4.06 0 0 0 0 5.745 4.06 4.06 0 0 0 5.745 0zm-2.822-2.923a4.037 4.037 0 0 0 1.295.871.372.372 0 0 0 .5-.227 2.337 2.337 0 0 0 .086-.478.377.377 0 0 0-.223-.365 2.917 2.917 0 0 1-.862-.6 2.941 2.941 0 0 1-.012-4.14l.011-.011 2.475-2.475a2.936 2.936 0 0 1 4.154 0 2.936 2.936 0 0 1 0 4.154L3.661-5.507a.377.377 0 0 0-.106.315c.016.124.033.325.038.449a.375.375 0 0 0 .631.259l.11-.106 2.475-2.474a4.06 4.06 0 0 0 0-5.745 4.06 4.06 0 0 0-5.745 0l-2.475 2.475a4.067 4.067 0 0 0 0 5.745z",
    transform: "translate(10 16)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6ef4dc2f83ebdef15c1480488fa05ed4.svg";
export { ForwardRef as ReactComponent };